/* 劉備傳・第 3 章：下邳失守（建安元年，196）
 * 史實：《三國志·先主傳》袁術來攻，劉備在盱眙、淮陰拒之；呂布趁虛襲取下邳，俘虜了劉備的妻子，劉備轉軍海西。
 * 流程：夜裡從前線趕回，下邳已經落入呂布手中（城門關著）。在城外收攏散兵和家眷（走到他們身邊就跟上）；
 *       呂布的騎兵比你快，追上來就躲進草叢甩掉他們。帶著家眷往東撤到海西即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS } from '../kit.ts';
import { CITY, GATE } from '../maps/xiapi.ts';

const LV = 8, START = [3000, 4400], EXIT = [8200, 2400];
const GROUPS = [[3800, 3300, '散兵'], [1600, 3600, '散兵'], [3000, 1800, '家眷'], [2800, 3200, '散兵']];
const CAV = { spec: TROOPS.dong, name: '呂布騎', hp: 460, maxHp: 460, atk: 28, ms: 285 };

export default {
  id: 'liubei-3', map: 'xiapi', hero: 'liubei',
  title: '第 3 章　下邳失守', year: '建安元年（196）',
  brief: {
    quote: [{ text: '先主轉軍海西。', src: '《三國志·蜀書·先主傳》' }],
    text: '劉備領徐州，袁術來攻，劉備帶兵到盱眙、淮陰抵擋。下邳守將曹豹反叛，暗中迎接呂布，呂布襲取下邳，俘虜了劉備的家眷（〈先主傳〉：「下邳守將曹豹反，間迎布。」）。',
    goals: ['收攏散兵與家眷', '躲開呂布的騎兵', '往東撤到海西'],
  },
  words: { ally: '散兵', foe: '呂布騎' },
  stars: [
    { text: '收攏 10 人以上', ok: (m) => m.vars.got >= 10 },
    { text: '家眷平安到海西', ok: (m) => m.vars.family && m.vars.family.every((u) => u.alive) },
    { text: '沒被騎兵追上（撤退時沒受傷）', ok: (m) => !m.vars.hit },
  ],
  steps: [
    { // 1. 收攏
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.got = 0;
        V.zf = ally(w, 'zhangfei', 1700, 3700, LV);
        m.gate('city', GATE[0], GATE[1], 190, 'citygate', ['張飛', '大哥……曹豹反了，城丟了！']);
        V.groups = GROUPS.map(([x, y, name], g) => {
          m.mark('g' + g, x, y, name, true);
          return Array.from({ length: name === '家眷' ? 2 : 3 }, (_, i) => { const u = m.recruit(x + (i - 1) * 60, y + (i % 2) * 40, name); if (name === '家眷') { u.hp = u.maxHp = 300; u.atk = 4; u.family = true; u.noFight = true; } return u; });
        });
        V.family = V.groups.flat().filter((u) => u.family);
        m.line('劉備', '下邳……城頭換了呂布的旗子！');
        m.after(3, () => m.line('提示', '城外散著劉備的兵和家眷，走到他們身邊就會跟上。呂布的騎兵比你快——躲進草叢就能甩掉。'));
        m.obj('gather', '收攏散兵與家眷', GROUPS.reduce((s, g) => s + (g[2] === '家眷' ? 2 : 3), 0));
        V.cavT = 25; V.cav = [];
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.groups.forEach((list, g) => { for (const u of list) if (u.alive && !u.owner && SG.gd(u.x, u.y, me.x, me.y) < 170) { m.join(u, me); V.got++; m.unmark('g' + g); } });
        m.prog('gather', V.got);
        cavalry(m, w, dt);
        if (V.got >= 8 && !V.told) { V.told = true; m.mark('exit', EXIT[0], EXIT[1], '海西'); m.line('劉備', '人收得差不多了，往東撤，去海西！'); }
        return V.told && me.x > EXIT[0] - 1200;
      },
    },
    { // 2. 轉軍海西
      enter(m) { m.done('gather'); m.obj('exit', '撤到海西'); },
      tick(m, w, dt) {
        cavalry(m, w, dt);
        if (!m.near(w.player, EXIT[0], EXIT[1], 300)) return false;
        m.done('exit'); m.unmark('exit');
        m.card('先主轉軍海西。', '《先主傳》');
        m.after(4, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('劉備陣亡'); return; }
    if (V.zf) { if (!V.zf.joined && SG.gd(V.zf.x, V.zf.y, w.player.x, w.player.y) < 200) { V.zf.joined = true; m.line('張飛', '大哥……曹豹反了，城丟了！'); m.after(2.5, () => m.line('劉備', '先別說了，人要緊。')); } if (V.zf.joined) allyTick(w, V.zf, w.player); }
    if (V.hp0 != null && w.player.hp < V.hp0 - 1 && V.cav.some((u) => u.alive && SG.gd(u.x, u.y, w.player.x, w.player.y) < 250)) V.hit = true;
    V.hp0 = w.player.hp;
  },
};

// 呂布的騎兵：從城門出來追劉備；看不到人（躲進草叢）就在原地找一下再回城
function cavalry(m, w, dt) {
  const V = m.vars, me = w.player;
  V.cavT -= dt;
  if (V.cavT <= 0) {
    V.cavT = 14;
    m.line('呂布騎', '劉備在那裡！追！');
    for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', GATE[0] - 250 - (i % 2) * 60, GATE[1] - 80 + i * 50, CAV); u.home = [me.x, me.y]; V.cav.push(u); } // 斥候報了劉備的位置
  }
  for (const u of V.cav) {
    if (!u.alive || (u.target && u.target.alive)) continue;
    if (me.vis[1] || SG.gd(u.x, u.y, me.x, me.y) < 900) u.home = [me.x, me.y]; // 看得到（或就在附近）就追
    else if (SG.gd(u.x, u.y, u.home[0], u.home[1]) < 60) u.home = [GATE[0] - 300, GATE[1]]; // 追丟了：回城
  }
}
